import getDisplayValue from './get-display-value';
const getSelectOptions = (entitySchema, propsToDisplay) => {
  if (!propsToDisplay || !propsToDisplay.length) return [];
  const {
    properties = {},
    dynamicProperties = {}
  } = entitySchema;
  return propsToDisplay.map(propToDisplay => {
    const displayValue = getDisplayValue(propToDisplay, properties) || getDisplayValue(propToDisplay, dynamicProperties) || propToDisplay;
    return [propToDisplay, displayValue];
  });
};
export default getSelectOptions;
//# sourceMappingURL=get-select-options.js.map